export const planningContext = {
  title: "Filtre",
  'all-plannings': "Tous les plannings",
  user: {
    label: "Sélectionnez un utilisateur",
    title: "Veuillez sélectionner un utilisateur"
  },
  office: {
    label: "Sélectionnez un cabinet",
    title: "Veuillez sélectionner un cabinet"
  },
  planning: {
    label: "Sélectionnez un planning",
    title: "Veuillez sélectionner un planning"
  },
  year1: {
    label: "Année 1",
    placeholder: "ex : 2016",
    title: "Indiquez l'année pour l'évolution 1"
  },
  year2: {
    label: "Année 2",
    placeholder: "ex : 2017",
    title: "Indiquez l'année pour l'évolution 2"
  }
}
